import React from 'react'
import { Divider, Grid } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'

import { Header, Page, CustomButton, SecaoGenerica } from 'components'
import { DescricoesVestigiosExame } from 'components/DescricoesVestigiosExame'
import { FormQuesitos } from 'views/ExamesRealizados/components/FormQuesitos'
import { useStyles } from './ExameIdentificacaoBalistica.styles'
import { useExameIdentificacaoBalistica } from './hooks/useExameIdentificacaoBalistica'

export const ExameIdentificacaoBalistica = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    params,
    processandoAlteracaoRespostas,
    setRespostasQuesitos,
    setAtualizado,
    handleFinalizarExame,
    router,
  } = useExameIdentificacaoBalistica(route.tipoExame)

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />


      <Grid item sm={12} xs={12} md={12}>
        <DescricoesVestigiosExame
          idExameSolicitado={params.idExameSolicitado}
          idExameRealizado={params.idExameRealizado}
          setAtualizado={setAtualizado}
        />
      </Grid>


      <SecaoGenerica titulo="RESPOSTAS DOS QUESITOS" spacing={2}>
        <Grid item sm={12} xs={12} md={12}>
          <FormQuesitos
            idExameRealizado={params.idExameRealizado}
            setRespostasComponentePai={setRespostasQuesitos}
          />
        </Grid>
      </SecaoGenerica>

      <Grid item xs={12}>
        <Divider />
      </Grid>


      <Grid container justifyContent="space-between" className={classes.botoesFormulario}>
        <Grid item>
          <CustomButton
            variant="outlined"
            onClick={() => router.history.goBack()}
            startIcon={<ArrowBackIcon />}
          >
            Voltar
          </CustomButton>
        </Grid>
        <Grid item>
          <CustomButton
            variant="contained"
            color="primary"
            isLoading={processandoAlteracaoRespostas}
            onClick={handleFinalizarExame}
            startIcon={<SaveIcon />}
          >
            Finalizar
          </CustomButton>
        </Grid>
      </Grid>
    </Page>
  )
}

/**
 * @description Função equivalente à lógica de descrição de vestígios do backend (sigep-api).
 * Utilizada para organizar as descrições técnicas por tipo para exibição.
 */
export const gerarDadosDescricaoVestigio = (descricoesTecnicas, idVestigio) => {
  const descricoes = descricoesTecnicas.filter((d) => d.id_vestigio === idVestigio)

  return {
    armas: descricoes.filter(
      (d) => d.tipoVestigioEspecifico === 'ARMA_DE_FOGO' || d.tipoVestigioEspecifico === 'ARMA_DE_PRESSAO'
    ),
    cartuchos: descricoes.filter((d) => d.tipoVestigioEspecifico === 'CARTUCHO'),
    estojos: descricoes.filter((d) => d.tipoVestigioEspecifico === 'ESTOJO'),
    projeteis: descricoes.filter((d) => d.tipoVestigioEspecifico === 'ELEMENTO_MUNICAO'),
    carregadores: descricoes.filter((d) => d.tipoVestigioEspecifico === 'CARREGADOR'),
    outros: descricoes.filter(
      (d) =>
        !['ARMA_DE_FOGO', 'ARMA_DE_PRESSAO', 'CARTUCHO', 'ESTOJO', 'ELEMENTO_MUNICAO', 'CARREGADOR'].includes(
          d.tipoVestigioEspecifico
        )
    ),
  }
}
